import { useEffect } from 'react';
import { useBooking } from '../context/BookingContext';
import { trackEvent } from '../utils/trackEvent';

const getTrackedPageReachedHotelIds = () => {
  try {
    return JSON.parse(sessionStorage.getItem('journey_page_reached_hotel_ids') || '[]');
  } catch (e) {
    return [];
  }
};

const JourneyTracker = () => {
  const { state } = useBooking();
  const hotelId = state.searchState.hotelId;

  useEffect(() => {
    if (!hotelId) return;

    const trackedHotelIds = getTrackedPageReachedHotelIds();
    const hotelIdKey = String(hotelId);

    if (trackedHotelIds.includes(hotelIdKey)) return;

    trackEvent('page_reached', { hotel_id: hotelId });
    sessionStorage.setItem(
      'journey_page_reached_hotel_ids',
      JSON.stringify([...trackedHotelIds, hotelIdKey])
    );
  }, [hotelId]);

  return null;
};

export default JourneyTracker;
